import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { WorkspacesListBaseComponent } from "@mypxplat/xplat/features";
import { EventBusService, UserService, WindowService, WorkspaceService, environment, HelperService } from "@mypxplat/xplat/core";
import { AppService, AvoService, FirebaseService } from "@mypxplat/xplat/web/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AddWorkspaceComponent } from "../modals";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { filter, takeUntil, take } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { BreadcrumbItem } from "../fender-ui/layout-header/layout-header.component";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-workspaces-list",
  templateUrl: "fui-workspaces-list.component.html",
  standalone: false,
})
export class FuiWorkspacesListComponent extends WorkspacesListBaseComponent implements OnInit {
  @Input() isCloud: boolean = true;
  public selectedID: any;
  public invites: Array<any>;
  public loadingInvites: boolean;
  public displayedSection: string = "workspaces";
  public filterQuery: string = "";
  public loading: boolean = true;
  public breadcrumbs: BreadcrumbItem[] = [];
  constructor(
    userService: UserService,
    public workspaceService: WorkspaceService,
    public appService: AppService,
    public router: Router,
    public fbAuth: AngularFireAuth,
    public db: AngularFirestore,
    private _activatedRoute: ActivatedRoute,
    private _win: WindowService,
    private _eventbusService: EventBusService,
    public avoService: AvoService,
    public fbService: FirebaseService,
    private _router: Router,
    public helperService: HelperService
  ) {
    super(userService, workspaceService);
  }

  ngOnInit() {
    this.loadingInvites = true;
    this.breadcrumbs = [{ label: "header.nav.home", routerLink: ["/home"] }, { label: "sphere.workspaces.workspaces" }];
    super.ngOnInit();
    const go = () => {
      this.workspaceService.workspaces$
        .pipe(
          filter((items) => !!items),
          takeUntil(this.destroy$)
        )
        .subscribe((results: any) => {
          this.setupMissedMessages(results);
          this.processWorkspaces(this.workspaces);

          this.sortWorkspaces();
        });
      this.workspaceService.collabs$
        .pipe(
          filter((items) => !!items),
          takeUntil(this.destroy$)
        )
        .subscribe((result) => {
          this.setupMissedMessages(result);
          this.processWorkspaces(this.collabs);
          this.sortWorkspaces();
        });
      this.getInvites();
    };
    go();
    if (this._activatedRoute.snapshot.params["id"]) {
      if ((this.workspaces && this.workspaces.length) || (this.collabs && this.collabs.length)) {
        let defaultWorkspace = this.workspaces.filter((w) => w["id"] == this._activatedRoute.snapshot.params["id"])[0];
        if (!defaultWorkspace) this.collabs.filter((w) => w["id"] == this._activatedRoute.snapshot.params["id"])[0];
        let workspaceName = undefined;
        if (defaultWorkspace !== undefined) {
          workspaceName = defaultWorkspace["name"];
        }
        this.selectWorkspace(this._activatedRoute.snapshot.params["id"], workspaceName, false);
      }
    } else {
      this.appService.mobileMenuShown = true;
    }
  }

  processWorkspaces(workspaces) {
    this.loading = false;
    workspaces.forEach((workspace) => {
      workspace.gradient = this.appService.generateRandomGradient();
    });
  }

  sortWorkspaces() {
    if (this.appService.sortBy == "date") {
      if (this.workspaces.length)
        this.workspaces.sort((a, b) => (a.date_created > b.date_created ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1));
      if (this.collabs.length) this.collabs.sort((a, b) => (a.date_created > b.date_created ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1));
    } else {
      if (this.workspaces.length) this.workspaces.sort((a, b) => (a.name > b.name ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1));
      if (this.collabs.length) this.collabs.sort((a, b) => (a.name > b.name ? (this.appService.sortDirection == "asc" ? 1 : -1) : this.appService.sortDirection == "asc" ? -1 : 1));
    }
  }

  selectWorkspace(id, name, route = true) {
    this.selectedID = undefined;
    if (route) {
      this._win.setTimeout(() => {
        this.selectedID = id;
        this.router.navigate(["workspaces/detail/", id], {
          replaceUrl: true,
        });
      }, 10);
    } else {
      this.selectedID = id;
    }
    if (id != null && id !== "") {
      const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
      const te = this.avoService.trackEvent();
      if (te && typeof te.workspaceViewed === "function") {
        const extra = { name: "Workspace Detail", workspaceId: parseInt(id, 10), eventType: "create", interactionType: "viewed" };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        te.workspaceViewed(payload);
      }
    }
  }

  goToWorkspace(id) {
    this.router.navigate(["workspaces/detail/", id]);
  }

  showInvitations() {
    this.selectedID = undefined;
    this._win.setTimeout(() => {
      this.router.navigate(["workspaces"], {
        replaceUrl: true,
      });
    }, 10);
  }

  setupMissedMessages(results) {
    results.forEach((workspace) => {
      if (workspace.firebase_timeline_id) {
        this.timelineRefs[workspace.firebase_timeline_id] = this.fbService.doc(`timelines/${workspace.firebase_timeline_id}`);
        this.fbService
          .handleFirestoreObservable(() => this.fbService.doc(`timelines/${workspace.firebase_timeline_id}/missedMessages/${this.user.id}`).get())
          .subscribe({
            next: (result: any) => {
              this.unReadCounts[workspace.id] = result?.data && result.data() ? result.data().missedCount : 0;
            },
            error: (error) => {},
          });
      }
    });
  }

  go(id) {
    this.router.navigate(["workspaces/detail/", id]);
  }

  workspacesVideo() {
    this.appService.showVideo(environment.fspPlusLearnMoreVideoId);
  }

  getInvites() {
    if (this.workspaceService.cachedCollaborationInvites) this.invites = this.workspaceService.cachedCollaborationInvites;
    this.workspaceService.getCollaborationInvites(true).subscribe((invites) => {
      this.gotInvites(invites);
    });
  }

  gotInvites(invites) {
    this.loadingInvites = false;
    this.invites = invites;
  }

  add() {
    if (!this.user.active_subscription) {
      this.appService.goToCheckout("/onboarding?subscribeOnly=true");
    } else {
      this.appService.showModal(AddWorkspaceComponent, { size: "xl" });
    }
  }

  switchSection(section, force?, skipNavigation?) {
    if (section != this.displayedSection && !skipNavigation) {
      // let url = ["workspaces/", section];
      // if (section == "options") url = ["support/"];
      // this._router.navigate(url);
    }
    this.displayedSection = section;
  }
}
